import React from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";

export const PrintButton = () => (
  <Button
    variant="outline-link"
    className="no-print"
    style={{
      marginBottom: 8,
    }}
    onClick={() => window.print()}
  >
    <FontAwesomeIcon icon={faPrint} color="#212529" />
    <span style={{ marginLeft: 8 }}>Print</span>
  </Button>
);
